// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/header.css
// module id = 4172
// module chunks = 0